import * as React from "react";

function ResetSection(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
            <path
                d="M6.41747 14H1.41747V19M15.8351 12.9968C15.2744 14.3846 14.3356 15.5872 13.1255 16.468C11.9154 17.3488 10.4825 17.8725 8.98959 17.9795C7.49669 18.0865 6.00371 17.7726 4.68034 17.0734C3.35697 16.3742 2.25629 15.3177 1.50341 14.0241M10.4175 6H15.4175V1M1 7.00315C1.56068 5.6154 2.49943 4.41278 3.70954 3.53197C4.91965 2.65116 6.35259 2.12749 7.84549 2.02047C9.33839 1.91346 10.8314 2.2274 12.1547 2.92661C13.4781 3.62582 14.5788 4.68226 15.3317 5.97584"
                stroke="white"
                strokeWidth="1.62"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ResetSection;
